module.exports = __webpack_public_path__ + "static/media/btn_point_zbottom_nor.a40653c4.svg";